export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14651.0f5f1939.jpg";